// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__fcUrY","bigColWidth":"Table_bigColWidth__CNoHV","biggerColWidth":"Table_biggerColWidth__293Zo","row":"Table_row__1xusn","col":"Table_col__GydCL"};